/** 站点版权声明文案 */
export const SITE_COPYRIGHT = "© 2026 拓影 ToVid. All rights reserved.";

/** 站点 ICP 备案号展示文案 */
export const SITE_ICP_TEXT = "粤ICP备2026118182号-1";

/** 服务条款 PDF 预览地址（隐藏浏览器默认工具栏） */
export const SITE_TERMS_PDF = "/legal/terms-of-service.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=90";

/** 隐私政策 PDF 预览地址（隐藏浏览器默认工具栏） */
export const SITE_PRIVACY_PDF = "/legal/privacy-policy.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=90";
